<template lang="pug">
  .registry.owner-update
    router-view

    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendOwnerForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row.owner-update__row
              .modal__col
                template(v-if="fields.owner_type !== OWNER_TYPES.company")
                  e-form-group(
                    name="firstname"
                    inputType="input"
                    label="Имя"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="lastname"
                    inputType="input"
                    label="Фамилия"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    name="surname"
                    inputType="input"
                    label="Отчество"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    v-if="fields.owner_type === OWNER_TYPES.person"
                    name="person_passport_id"
                    inputType="input"
                    label="Номер документа удостоверяющий личность"
                    :model="fields"
                    tabView="tab1"
                  )
                  e-form-group(
                    v-if="fields.owner_type === OWNER_TYPES.person"
                    name="person_passport_date"
                    inputType="calendar"
                    label="Дата выдачи документа"
                    :model="fields"
                    tabView="tab1"
                    type="date"
                  )
                e-form-group(
                  v-if="fields.owner_type !== OWNER_TYPES.person"
                  name="org_full_name"
                  inputType="name"
                  label="Полное наименование"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  v-if="fields.owner_type === OWNER_TYPES.company"
                  name="org_shortname"
                  inputType="name"
                  label="Краткое наименование"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="org_status"
                  inputType="select"
                  :required="true"
                  label="Статус"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="inn"
                  inputType="inn"
                  label="ИНН"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  v-if="fields.owner_type === OWNER_TYPES.company"
                  name="kpp"
                  inputType="input"
                  label="КПП"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :onChangeValidation="true"
                  :onChangeValidationOptions="{disableAutoFocus: true}"
                  :validationAdditionalRules="{minLen: 9, maxLen: 9}"
                )
                e-form-group(
                  v-if="fields.owner_type !== OWNER_TYPES.person"
                  name="ogrn"
                  inputType="ogrn"
                  label="ОГРН"
                  validationRule="number"
                  :model="fields"
                  tabView="tab1"
                  :onChangeValidation="true"
                  :onChangeValidationOptions="{disableAutoFocus: true}"
                  :validationAdditionalRules="{specialValidate: validateOgrn}"
                )
                e-form-group(
                  v-if="fields.owner_type !== OWNER_TYPES.person"
                  name="okpo"
                  inputType="input"
                  label="ОКПО/ОГРНИП"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="fields.owner_type !== OWNER_TYPES.person"
                  name="okved"
                  inputType="input"
                  label="ОКВЭД 2"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
              .modal__col
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  addressIdFieldName="fact_address_id"
                  :required="true"
                  :addressData="addressData"
                  tabView="tab1"
                )
                e-form-group(
                  name="contacts"
                  inputType="input"
                  label="Контактные данные"
                  :model="fields"
                  tabView="tab1"
                )
              .modal__col
            owner-relatives(v-if="hasMemberChoose" )
</template>

<script>
import { owner } from '@/api/api-endpoints'
import formBaseMixin from '@/components/form/form-base-mixin'
import { OWNER_TYPES } from '@/config/config'
import url from '@/utils/url'
import hasMixin from '@/mixins/has-mixin'
import OwnerRelatives from './components/owner-relatives'

export default {
  name: 'OwnerUpdate',
  components: { OwnerRelatives },
  mixins: [formBaseMixin, hasMixin],
  data: () => ({
    tabView: 'tab1',
    fields: {
      role_id: '',
      owner_type: '',
    },
    errors: null,
  }),
  computed: {
    tabs() {
      return [{ tab1: 'Общие сведения' }]
    },
    OWNER_TYPES() {
      return OWNER_TYPES
    },
    statuses() {
      return [
        {
          id: true,
          name: 'Действующий',
          code: 'active',
        },
        {
          id: false,
          name: 'Не действующий',
          code: 'disabled',
        },
      ]
    },
  },
  methods: {
    transformFieldsBeforeSend() {
      if (this.fields.owner_type === OWNER_TYPES.person) {
        this.fields.org_full_name =
          this.fields.firstname + ' ' + this.fields.lastname
      }
    },
    getDeleteUrl(id) {
      return owner.ownerDelete(id)
    },
    getUpdateOrCreateUrl() {
      return owner.owner(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return owner.owner(route.params.id)
    },
    validateOgrn(errMsg) {
      if (
        this.fields.ogrn &&
        this.fields.ogrn.length !== 13 &&
        this.fields.ogrn.length !== 15
      ) {
        errMsg += 'ОГРН должен состоять из 13 цифр, ОГРНИП - из 15 цифр'
      }
      return errMsg
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
    sendOwnerForm() {
      this.sendForm().then((r) => {
        const route = url.getRoute(this.$route)
        let prevRoute = url.getPrevRoute(route)
        prevRoute = url.encode(prevRoute)
        prevRoute.params.owner_id = r.data.id
        prevRoute.params.org_full_name = r.data.org_full_name
        let nestedPrevRoute = url.getPrevRoute(prevRoute)
        nestedPrevRoute = url.encode(nestedPrevRoute)
        nestedPrevRoute.params.owner_id = r.data.id
        nestedPrevRoute.params.org_full_name = r.data.org_full_name
        prevRoute.query.prevRoute = url.decode(nestedPrevRoute)
        route.query.prevRoute = url.decode(prevRoute)
        this.$router.push({
          name: route.name,
          params: route.params,
          query: route.query,
        })
      })
    },
  },
  created() {
    this.fields.owner_type = this.$route.params.owner_type
  },
}
</script>
